import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as rccActions from "../../actions/rccActions";
import * as barcodeActions from "../../actions/barcodeActions";

import CanisterBarcodeModalComponent from "../../components/global/modal/CanisterBarcodeModal";
import CanisterBarcodeModalGammaComponent from "../../components/global/modal/CanisterBarcodeModalGamma";

class CanisterBarcodeModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseCanisterBarcodeModalAction();
    };

    setCanisterBarcode = (id, barcode) => {
        if (barcode === "") {
            this.props.dispatchDeleteItemConfirmationAction(
                componentTypes.MODAL_NO_TAB,
                rccActions.setCanisterBarcode(id, barcode)
            );
        } else {
            this.props.dispatchSetCanisterBarcodeAction(id, barcode);
        }
    };

    setResetButton = () => {
        this.props.dispatchResetBarcodeAction();
    };

    showManualBarcodeScan = (show) => {
        this.props.dispatchShowManualScanAction(show);
    };

    render() {
        if (this.props.gammaSoftware) {
            return (
                <CanisterBarcodeModalGammaComponent
                    tabId={this.props.tabId}
                    barcode={this.props.barcode}
                    canisterList={this.props.canisterList}
                    colorantList={this.props.colorantList}
                    connected={this.props.connected}
                    closeModal={this.closeModal}
                    setCanisterBarcode={this.setCanisterBarcode}
                    setResetButton={this.setResetButton}
                    showManualBarcodeScan={this.showManualBarcodeScan}
                    id={this.props.id}
                />
            );
        }

        return (
            <CanisterBarcodeModalComponent
                tabId={this.props.tabId}
                barcode={this.props.barcode}
                canisterList={this.props.canisterList}
                colorantList={this.props.colorantList}
                connected={this.props.connected}
                closeModal={this.closeModal}
                setCanisterBarcode={this.setCanisterBarcode}
                setResetButton={this.setResetButton}
                showManualBarcodeScan={this.showManualBarcodeScan}
                loggedUser={this.props.loggedUser}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        helpSettings: store.settings.helpSettings,
        barcode: store.barcode.barcode,
        canisterList: store.rcc.canisterList,
        colorantList: store.global.allColorantList,
        connected: store.rcc.connected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseCanisterBarcodeModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CANISTER_BARCODE_MODAL));
        },
        dispatchSetCanisterBarcodeAction: (id, barcode) => {
            dispatch(rccActions.setCanisterBarcode(id, barcode));
        },
        dispatchResetBarcodeAction: () => {
            dispatch(barcodeActions.saveBarcode(""));
        },
        dispatchDeleteItemConfirmationAction: (tabId, action) => {
            dispatch(navigationActions.deleteItemConfirmation(tabId, action));
        },
        dispatchShowManualScanAction: (show) => {
            dispatch(barcodeActions.showManualScan(show));
        }
    };
};

export default CanisterBarcodeModal = connect(mapStoreToProps, mapDispatchToProps)(CanisterBarcodeModal);
